import { render, staticRenderFns } from "./MyItemDialogComponent.vue?vue&type=template&id=3e115cfa&scoped=true"
import script from "./MyItemDialogComponent.vue?vue&type=script&lang=js"
export * from "./MyItemDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e115cfa",
  null
  
)

export default component.exports